import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './update-confirm-popup.module.scss';
import UTEButton from 'src/components/ute-button';
import CloseIconUTEModal from 'src/assets/svg/close-icon-ute-modal';

interface UpdateConfirmPopupProps {
	show: boolean;
	onClose: () => void;
	onConfirm: () => void;
	confirmButtonDisabled: boolean;
}
const UpdateConfirmPopup = ({ show, onClose, onConfirm, confirmButtonDisabled }: UpdateConfirmPopupProps) => {
	return (
		<>
			<Modal
				show={show}
				className={styles.modal}>
				<div className={styles.modalContent}>
					<Modal.Header className={styles.header}>
						<div>
							<Modal.Title className={styles.title}>Confirm Update</Modal.Title>
						</div>
						<div
							className={styles.closeIcon}
							onClick={onClose}>
							<CloseIconUTEModal />
						</div>
					</Modal.Header>
					<Modal.Body className={styles.body}>
						<div className={styles.updateMessage}>
							Are you sure you want to make this update?
							<div className={styles.marginTop23}>
								Changes to the name, email, or phone number will require <span> reauthentication </span> by the third
								party.
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer className={styles.footer}>
						<UTEButton
							text='No'
							className={styles.noButton}
							onClick={onClose}
							disabled={confirmButtonDisabled}
							dataTestAuto='e74c8d9b-5338-4f56-9540-7f2a37c6da18'
						/>
						<UTEButton
							text='Yes'
							className={styles.yesButton}
							onClick={onConfirm}
							disabled={confirmButtonDisabled}
							dataTestAuto='a7f3c1de-4a52-479d-8a95-dfbd659c9607'
						/>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
};

export default UpdateConfirmPopup;
